import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ModalController, AlertController, ViewController, App } from 'ionic-angular';
import { HttpService } from '../../services/HttpService';

import { LoginPage } from '../login/login';
import { DeleteaccountPage } from '../deleteaccount/deleteaccount';

/**
 * Generated class for the MyaccountPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-myaccount',
  templateUrl: 'myaccount.html',
})
export class MyaccountPage {

  	loginId: string;
  	api_key: string;
  	version: string;

	texts: any = [];
    language : string;

	email: string;
	coin_unit: string;
	coin_list: any
	
	id: string;
	name: string;
	year: string;
	month: string;
	day: string;
	birthday: string;
	date: string;
	phone: string;
	country: string;
    branch: string;
	branch_name: string;
	center: string;
	center_name: string;
	chucheon: string;
	huwon: string;
	chucheon_active: string ='N';
	coin_address: string;
    
    country_list: any = [];
    center_list: any = [];
	
	is_enabled_btn_download: boolean = true;

	constructor(
		public navCtrl: NavController, 
		public navParams: NavParams, 
		public modalCtrl: ModalController,
		public alertCtrl: AlertController,
		private http: HttpService,
		public viewCtrl: ViewController,
		public app: App
	) {
	}

	ionViewWillEnter() {
		//// 로그인이 안되어 있다면 로그인 화면으로 이동한다.
		this.api_key = localStorage.getItem("api_key");
		this.loginId = localStorage.getItem("loginId");
		if(!this.api_key) {
			this.app.getRootNav().setRoot(LoginPage);
		}
		// 페이지 이름
		localStorage.setItem("pageName", "myaccount");
        this.language = localStorage.getItem("language");
        this.version = localStorage.getItem("version");

        this._get_texts();
		
		this._init();
	}

	_get_texts() {
		this.texts = JSON.parse(localStorage.getItem('lang_pack')).myaccount;
	}    

	_save() {
        this._birthday();

        if(!this._validate()) {
            return ;
        }

        let url = "user/info/index/save";
		let send_data = JSON.stringify({
			api: this.api_key,
            language: this.language,
            version: this.version,
			name: this.name,
			phone: this.phone,
			country: this.country,
			email: this.email,
			birthday: this.birthday,
        });
        this.http.post(url, send_data).then((res: any) => {
            if(res.result == "OK") {						
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
				alert.present();
				                
            } else if(res.result ==="LOGOUT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
                
                //// 에러메시지를 받았을때 표시한다.
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();                    
            }
        
        }, err => {
            
            //// HTTP 에러인 경우
            let alert = this.alertCtrl.create({
                message: err,
                buttons: ['OK']
            });
            alert.present();
        
        });
        return ;
			
	}

	//// 성명 / 생년월일 / 이메일이 수정 가능해지면서 저장 전에 값을 검사한다.
	_validate(): boolean {

        if(!this.name || this.name.trim().length == 0) {
            this._alert(this.texts.toastM_name || 'Please enter your name.');
            return false;
        }

        if(!this.email || this.email.trim().length == 0) {
            this._alert(this.texts.toastM_email || 'Please enter your email address.');
            return false;
        }

        if(!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email.trim())) {
            this._alert(this.texts.toastM_email_form || 'Please check your email address.');
            return false;
        }

        this.email = this.email.trim().toLocaleLowerCase();

        //// 생년월일은 세 칸을 모두 채우거나 모두 비워야 한다.
        let has_birthday = (this.year || "") != "" || (this.month || "") != "" || (this.day || "") != "";
        if(has_birthday) {
            if((this.year || "").length != 4 || (this.month || "") == "" || (this.day || "") == "") {
                this._alert(this.texts.toastM_birthday || 'Please check your date of birth.');
                return false;
            }

            let year = parseInt(this.year, 10);
            let month = parseInt(this.month, 10);
            let day = parseInt(this.day, 10);
            let now_year = new Date().getFullYear();

            if(year < 1900 || year > now_year || month < 1 || month > 12 || day < 1 || day > 31) {
                this._alert(this.texts.toastM_birthday || 'Please check your date of birth.');
                return false;
            }

            //// 2월 30일 같은 값을 걸러낸다.
            let check = new Date(year, month - 1, day);
            if(check.getFullYear() != year || check.getMonth() != month - 1 || check.getDate() != day) {
                this._alert(this.texts.toastM_birthday || 'Please check your date of birth.');
                return false;
            }
        }

        return true;
	}

	_alert(message: string) {
        let alert = this.alertCtrl.create({
            message: message,
            buttons: ['OK']
        });
        alert.present();
	}

	_init() {
        let url = "user/info";
		let send_data = JSON.stringify({
			api: this.api_key,
			language: this.language,
			version: this.version,
		});
		this.http.post(url, send_data).then((res: any) => {
            if(res.result == "OK") {
                this.id = res.id;
                this.name = res.name;
                this.email = res.email;
                this.phone = res.phone;
                this.country = res.country;
                this.branch = res.branch;
                this.branch_name = res.branch_name;
                this.center = res.center;
                this.center_name = res.center_name;
                this.chucheon = res.chucheon;
                this.birthday = res.birthday;

                let birthday = res.birthday;
                this.year = birthday.substring(0, 4);
                this.month = birthday.substring(5, 7);
                this.day = birthday.substring(8, 10);
                this.huwon = res.huwon;
				this.country_list = res.country_list;
				this.center_list = res.center_list;
				
            } else if(res.result ==="LOGOUT"){
				let alert = this.alertCtrl.create({
					message: res.message,
					buttons: ['OK']
				});
				alert.present();
				localStorage.removeItem("loginId");
				localStorage.removeItem("api_key");
				this.app.getRootNav().setRoot(LoginPage);
			
			} else {
                let alert = this.alertCtrl.create({
                    message: res.message,
                    buttons: ['OK']
                });
                alert.present();
            }
        }, err => {
            let alert = this.alertCtrl.create({
                message: err,
                buttons: ['OK']
            });
            alert.present();
        });
	}

    keyDown(mod) {

    }

    keyUp(mod) {
        var tmps: string;

        if (mod == "year") {
            if(this.year != null || this.year != "") {
                let tmps = this.year;
                this.year = tmps.replace(/[^0-9]/g, "");
            }
        }

        if (mod == "month") {
            if(this.month != null || this.month != "") {
                let tmps = this.month;
                this.month = tmps.replace(/[^0-9]/g, "");
            }
        }

        if (mod == "day") {
            if(this.day != null || this.day != "") {
                let tmps = this.day;
                this.day = tmps.replace(/[^0-9]/g, "");
            }
        }
	}

    _birthday() {
        if(this.month != "") {
            let tmps_month = this.month;
            this.month = tmps_month.padStart(2, "0");
        }

        if(this.day != "") {
            let tmps_day = this.day;
            this.day = tmps_day.padStart(2, "0");
        }

        if(this.month != "" && this.day != "") {
            this.birthday = this.year + "-" + this.month + "-" + this.day;
        } else {
            this.birthday = ""
        }
    }

	_close() {
		this.navCtrl.pop();
	}

    _delete() {
        let modal = this.modalCtrl.create(DeleteaccountPage);
        modal.present();
        // modal.onDidDismiss( data => {
        //     this.navCtrl.pop();
        // });

    }
}



// WEBPACK FOOTER //
// ./src/pages/myaccount/myaccount.ts